import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import {
  ModelResultType,
  useFormAiUnderwriterScoreReturnProps,
  FormFields
} from '../IGPRScore.interface';

export default function useFormAiUnderwriterScore(): useFormAiUnderwriterScoreReturnProps {
  const [openModal, setOpenModal] = useState(false);
  const initialModelResultState: ModelResultType = {
    prediction: 0,
    recommendation: ''
  };
  const [aiModelResponse, setAiModelResponse] = useState(
    initialModelResultState
  );

  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { isValid, errors }
  } = useForm<FormFields>({
    mode: 'all',
    defaultValues: {
      problems: [{ value: '' }],
      medications: [{ value: '' }],
      bmi: '',
      cholesterol: '',
      blood_pressure: '',
      blood_sugar: ''
    }
  });

  useEffect(() => {
    if (!isValid) setOpenModal(false);
  }, [isValid]);

  return {
    openModal,
    setOpenModal,
    control,
    register,
    handleSubmit,
    reset,
    isValid,
    errors,
    aiModelResponse,
    setAiModelResponse
  };
}
